/**
 * Plan type constants used to show specific plan-related fields and components
 */
export enum PlanType {
  FLEXI_OWN = "fo",
  FLEXI_TRY = "ft",
};

/**
 * Chargebee components for optional plan features
 */
export enum OptionalChargebeeComponents {
  PAYOUT_PROTECTION_FEE = "payoutprotectionfee",
  LOSS_AND_DAMAGE_PAYMENT = "lossanddamagepayment",
  SPLEND_MANAGEMENT_FEE = "splendmanagementfee",
  LOSS_AND_DAMAGE_COVER_PLUS = "lossanddamagecoverplus",
  SERVICING = "servicing",
  CONSUMABLES = "consumables",
};
